/* Sends the customer from the cart to the custom iKhokha checkout instead of Shopify's checkout.
   The checkout address comes from the snippet 'ikhokha-checkout' (window.IKHOKHA_CHECKOUT_URL). */
(function () {
  var base = (window.IKHOKHA_CHECKOUT_URL || '').replace(/\/+$/, '');
  if (!base) return;
  var busy = false;

  async function goToCheckout() {
    if (busy) return;
    busy = true;
    try {
      var root = (window.Shopify && Shopify.routes && Shopify.routes.root) || '/';
      var res = await fetch(root + 'cart.js', { headers: { Accept: 'application/json' }, cache: 'no-store' });
      var cart = await res.json();
      if (!cart.items || !cart.items.length) { busy = false; return; }
      var items = cart.items.map(function (i) { return i.variant_id + ':' + i.quantity; }).join(',');
      window.location.href = base + '/?items=' + encodeURIComponent(items);
    } catch (e) {
      busy = false;
      alert('Sorry, we could not start checkout. Please try again.');
    }
  }

  function isCheckoutTrigger(el) {
    if (!el || !el.closest) return false;
    return !!el.closest('[name="checkout"], a[href^="/checkout"], a[href*="/checkout?"], a[href$="/checkout"]');
  }

  document.addEventListener('click', function (e) {
    if (isCheckoutTrigger(e.target)) { e.preventDefault(); e.stopPropagation(); goToCheckout(); }
  }, true);

  document.addEventListener('submit', function (e) {
    var s = e.submitter;
    if (s && s.getAttribute && s.getAttribute('name') === 'checkout') { e.preventDefault(); e.stopPropagation(); goToCheckout(); }
  }, true);
})();
